'use client'

import { useState, useEffect } from 'react'
import { ChevronUpIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

const SCROLL_THRESHOLD = 300
const VIEWPORT_SELECTOR = '#main-scroll-area [data-radix-scroll-area-viewport]'

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const viewport = document.querySelector(VIEWPORT_SELECTOR)
    if (!viewport) {
      return
    }

    const onScroll = () => setVisible(viewport.scrollTop > SCROLL_THRESHOLD)
    viewport.addEventListener('scroll', onScroll, { passive: true })
    return () => viewport.removeEventListener('scroll', onScroll)
  }, [])

  const handleClick = () => {
    const viewport = document.querySelector(VIEWPORT_SELECTOR)
    viewport?.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (!visible) {
    return null
  }

  return (
    <Button
      variant="default"
      size="icon"
      onClick={handleClick}
      className="absolute right-6 bottom-0 z-50 mb-3 size-10 rounded-full shadow-md"
      aria-label="Scroll to top">
      <ChevronUpIcon className="size-4" />
    </Button>
  )
}

export default ScrollToTop
